import DescriptionHeadings from "@/shared/components/atoms/DescriptionHeadings";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClock } from "@fortawesome/free-regular-svg-icons";
import {
  faCircleDollar,
  faDumbbell,
  faCalendarCircleUser,
  faPersonWalking,
} from "@fortawesome/pro-regular-svg-icons";
import { t } from "i18next";
import React, { useEffect, useState } from "react";
import { InputWithCornerHint } from "@/shared/components/atoms/InputWithCornerHint";
import { Select } from "@/shared/components/organisms/Select";
import { optionsGender, revenueOption } from "@/shared/constants/constants";
import { DateRangePicker } from "@/shared/components/atoms/DataRangePicker";
import { formatDateUTC, parseDateUTC } from "@/shared/utils/formatedDate";
import {
  useGetAccessBranchQuery,
  useGetInactiveUsersForMonthQuery,
  useGetNewUsersForMonthQuery,
  useGetStatusClientsQuery,
  useGetUserLessQuery,
} from "@/app/kpi/kpi.api";
import { Option } from "@/shared/components/molecules/OptionsSelect";
import * as am5 from "@amcharts/amcharts5";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import * as am5xy from "@amcharts/amcharts5/xy";
import * as am5percent from "@amcharts/amcharts5/percent";
import {
  colorsKpi,
  configureExporting,
  initializeAmChart,
  Language,
  months,
  numberFormat,
} from "@/shared/utils/chartUtils";

const CaptationFidelizationComponent = () => {
  const [optionsCurrencies, setOptionsCurrencies] = useState<Option[]>([]);
  const [currencySelected, setCurrencySelected] = useState<Option>();
  const [userAverageBranch, setUserAverageBranch] = useState<number>();
  const [userTotalBranch, setUserTotalBranch] = useState<number>();
  const [ageMin, setAgeMin] = useState<number>();
  const [ageMax, setAgeMax] = useState<number>();

  const [sexSelected, setSexSelected] = useState<Option>(() => {
    const saved = localStorage.getItem("sexSelected");
    return saved ? JSON.parse(saved) : undefined;
  });
  const [revenueSelected, setRevenueSelected] = useState<Option>(() => {
    const saved = localStorage.getItem("revenueSelected");
    return saved ? JSON.parse(saved) : undefined;
  });

  useEffect(() => {
    if (optionsGender.length > 0 && !sexSelected) {
      setSexSelected(optionsGender[0]);
    }
    if (optionsCurrencies.length > 0 && !currencySelected) {
      setCurrencySelected(optionsCurrencies[0]);
    }
    if (revenueOption().length > 0 && !revenueSelected) {
      setRevenueSelected(revenueOption()[0]);
    }
  }, [optionsGender, optionsCurrencies, revenueOption, sexSelected, currencySelected, revenueSelected]);


  const { data: statusClients } = useGetStatusClientsQuery({
    age_min: ageMin,
    age_max: ageMax,
    sex: sexSelected?.id,
    currency_request: currencySelected?.id,
    revenue_source: revenueSelected?.id,
  });

  useEffect(() => {
    if (statusClients && statusClients.currency) {
      const currencyArray = Object.values(statusClients.currency);
      const currencies: Option[] = currencyArray.map((currency: any) => ({
        id: currency,
        name: currency,
      }));

      setOptionsCurrencies(currencies);
    }
  }, [statusClients]);

  const { data: getInactiveUser } = useGetInactiveUsersForMonthQuery({});
  const { data: getNewUsers } = useGetNewUsersForMonthQuery({});

  useEffect(() => {
    const systemLanguage: Language = navigator.language.slice(0, 2) as Language;
    const selectedMonths = months[systemLanguage] || months["en"];

    if (getInactiveUser && getNewUsers) {
      captionChart3(
        Object.values(getInactiveUser || {}),
        Object.values(getNewUsers || {}),
        selectedMonths
      );
    }
  }, [getInactiveUser, getNewUsers]);

  function captionChart3(inactiveUsers: any, newUsers: any, months: any) {
    am5.ready(function () {
      const root = initializeAmChart("chart_user_constiation");
  
      root.setThemes([am5themes_Animated.new(root)]);
  
      if (root._logo) {
        root._logo.dispose();
      }
  
      const chart = root.container.children.push(
        am5xy.XYChart.new(root, {
          paddingLeft: 50,
          paddingRight: 60,
          paddingTop: 10,
          paddingBottom: 50,
          layout: root.verticalLayout,
        })
      );
  
      const legend = chart.children.push(
        am5.Legend.new(root, {
          centerX: am5.percent(50),
          x: am5.percent(50),
          y: am5.percent(100),
          marginTop: 0,
        })
      );
  
      // Configurar las etiquetas de la leyenda para que sean de color gris
      legend.labels.template.setAll({
        fontSize: 12,
        fontWeight: "300",
        fill: am5.color(0x6b7280), // text-gray-500
      });
  
      // Configurar los valores de la leyenda para que sean de color gris
      legend.valueLabels.template.setAll({
        fontSize: 12,
        fontWeight: "300",
        fill: am5.color(0x6b7280), // text-gray-500
      });
  
      const data: any = [];
      months.forEach((month: string, index: number) => {
        data.push({
          month: month,
          active: newUsers[index] || 0,
          inactive: inactiveUsers[index] || 0,
        });
      });
  
      const xRenderer = am5xy.AxisRendererX.new(root, {
        cellStartLocation: 0.1,
        cellEndLocation: 0.9,
        minorGridEnabled: true,
        minGridDistance: 10,
      });
  
      const xAxis = chart.xAxes.push(
        am5xy.CategoryAxis.new(root, {
          categoryField: "month",
          renderer: xRenderer,
          tooltip: am5.Tooltip.new(root, {}),
        })
      );
  
      xRenderer.grid.template.setAll({
        location: 1,
        visible: false,
      });
  
      xAxis.get("renderer").labels.template.setAll({
        fontSize: "12px",
        fill: am5.color(0x6b7280),
      });
  
      xAxis.data.setAll(data);
  
      const yAxis = chart.yAxes.push(
        am5xy.ValueAxis.new(root, {
          renderer: am5xy.AxisRendererY.new(root, {}),
        })
      );
  
      // Configurar las etiquetas del eje Y para que sean de color gris
      yAxis.get("renderer").labels.template.setAll({
        fontSize: "12px",
        fill: am5.color(0x6b7280), // text-gray-500
      });
  
      function makeSeries(name: any, fieldName: any, color: any) {
        const series = chart.series.push(
          am5xy.ColumnSeries.new(root, {
            name: name,
            xAxis: xAxis,
            yAxis: yAxis,
            valueYField: fieldName,
            categoryXField: "month",
            stacked: false, // No apilado, para mostrar lado a lado
          })
        );
  
        series.columns.template.setAll({
          tooltipText: "{name}, {categoryX}: {valueY}",
          fill: am5.color(color),
          strokeOpacity: 0,
          fontSize: "0.8rem",
          stroke: undefined,
        });
        series.data.setAll(data);
        series.appear();
        legend.data.push(series);
      }
  
      makeSeries(t("share.views.new_clients_activated"), "active", colorsKpi[0]);
      makeSeries(t("share.views.deactivated_clients"), "inactive", colorsKpi[1]);
  
      chart.appear(1000, 100);
  
      // Configure exporting if needed
      configureExporting(root, data);
    });
  }

  const { data: getUserLess } = useGetUserLessQuery({});

  useEffect(() => {
    if (getUserLess) {
      captionChart1(getUserLess);
    }
  }, [getUserLess]);

  function captionChart1(userLess: any) {
    am5.ready(function () {
      const labels = [
        "0-4 días",
        "5-9 días",
        "10-14 días",
        "15-19 días",
        "+20 días",
        t("user.views.no_attendance"),
      ];
  
      const root = initializeAmChart("chart_12");
  
      root.setThemes([am5themes_Animated.new(root)]);
  
      if (root._logo) {
        root._logo.dispose();
      }
  
      const chart = root.container.children.push(
        am5percent.PieChart.new(root, {
          layout: root.verticalLayout,
          innerRadius: am5.percent(50),
        })
      );
      // Si no hay datos
      if (userLess.length === 0) {
        const label = root.container.children.push(
          am5.Label.new(root, {
            text: t("share.views.no_data"),
            fontSize: 34,
            fill: am5.color("#cbcac8"),
            centerX: am5.p50,
            centerY: am5.p50,
            x: am5.p50,
            y: am5.p50,
            horizontalCenter: "middle",
            verticalCenter: "middle",
          })
        );
        return;
      }
  
      const data: any = [];
      labels.forEach((label, index) => {
        data.push({
          category: label,
          value: userLess[index] || 0,
          color: colorsKpi[index % colorsKpi.length],
        });
      });
  
      const series = chart.series.push(
        am5percent.PieSeries.new(root, {
          name: "Series",
          categoryField: "category",
          valueField: "value",
          alignLabels: false,
        })
      );
      series.get("colors").set("colors", colorsKpi);
      series.data.setAll(data);
  
      series.labels.template.setAll({
        text: "{category}: {value}",
        fontSize: "8px", // Reducir el tamaño de la fuente
        fontWeight: "300",
        forceHidden: true,
      });
  
      series.slices.template.setAll({
        tooltipText: "{category}: {value}",
        fillOpacity: 1,
        strokeWidth: 0,
      });
  
      const legend = chart.children.push(
        am5.Legend.new(root, {
          centerX: am5.percent(50),
          x: am5.percent(50),
          marginTop: 15,
          marginBottom: 15,
        })
      );
  
      // Configurar las etiquetas de la leyenda para que sean de color gris
      legend.labels.template.setAll({
        fontSize: 14,
        fontWeight: "300",
        fill: am5.color(0x6b7280), // text-gray-500
      });

      legend.valueLabels.template.setAll({
        fontSize: 14,
        fontWeight: "300",
        fill: am5.color(0x6b7280), // text-gray-500
      });
  
      legend.data.setAll(series.dataItems);
  
      chart.appear(1000, 100);
      configureExporting(root, data);
    });
  }

  const { data: getAccessBranch } = useGetAccessBranchQuery({});

  useEffect(() => {
    if (getAccessBranch) {
      const dayChartArray: string[] = [];
      let userTotalBranch = 0;
      let userAverageBranch = 0;
      const accessData: any = [];

      getAccessBranch.map((accessItem: any) => {
        const date = accessItem["day"] + "/" + accessItem["month"];
        dayChartArray.push(`'${date}'`);
        userTotalBranch += accessItem["total"] ?? 0;
        userAverageBranch = accessItem["average"];
        accessData.push(accessItem["total"]);
      });

      captionChart2(dayChartArray, accessData);
      setUserTotalBranch(userTotalBranch);
      setUserAverageBranch(userAverageBranch ?? 0);
    }
  }, [getAccessBranch]);

  function captionChart2(categories: any, seriesData: any) {
    am5.ready(function () {
      const root = initializeAmChart("chart_31");
  
      root.setThemes([am5themes_Animated.new(root)]);
  
      if (root._logo) {
        root._logo.dispose();
      }
  
      const chart = root.container.children.push(
        am5xy.XYChart.new(root, {
          panX: false,
          panY: false,
          wheelX: undefined,
          wheelY: undefined,
          paddingLeft: 0,
          paddingRight: 0,
          layout: root.verticalLayout,
        })
      );
  
      console.log("seriesData", seriesData);
      if (seriesData.every((num: any) => num === 0)) {
        const label = root.container.children.push(
          am5.Label.new(root, {
            text: t("share.views.no_data"),
            fontSize: 20,
            fill: am5.color("#cbcac8"),
            centerX: am5.p50,
            centerY: am5.p50,
            x: am5.p50,
            y: am5.p50,
            horizontalCenter: "middle",
            verticalCenter: "middle",
          })
        );
        return;
      }
  
      const data: any = [];
      categories.forEach((category: any, index: any) => {
        data.push({
          category: category,
          value: seriesData[index] || 0,
        });
      });
  
      const xRenderer = am5xy.AxisRendererX.new(root, {
        cellStartLocation: 0.1,
        cellEndLocation: 0.9,
        minorGridEnabled: true,
        minGridDistance: 20,
      });
  
      const xAxis = chart.xAxes.push(
        am5xy.CategoryAxis.new(root, {
          categoryField: "category",
          renderer: xRenderer,
          tooltip: am5.Tooltip.new(root, {}),
        })
      );
  
      xRenderer.labels.template.setAll({
        rotation: -45,
        centerY: am5.p50,
        centerX: am5.p100,
        paddingRight: 15,
        fill: am5.color(0x6b7280), // text-gray-500
      });
      xRenderer.grid.template.setAll({
        location: 1,
        visible: false,
      });
  
      const yAxis = chart.yAxes.push(
        am5xy.ValueAxis.new(root, {
          renderer: am5xy.AxisRendererY.new(root, {}),
        })
      );
  
      // Configurar las etiquetas del eje Y para que sean de color gris
      yAxis.get("renderer").labels.template.setAll({
        fontSize: "12px",
        fill: am5.color(0x6b7280), // text-gray-500
      });
  
      xAxis.data.setAll(data);
  
      const series = chart.series.push(
        am5xy.ColumnSeries.new(root, {
          name: t("assisteds.views.assisted"),
          xAxis: xAxis,
          yAxis: yAxis,
          valueYField: "value",
          categoryXField: "category",
        })
      );
  
      series.data.setAll(data);
  
      // Deshabilitar el borde de las columnas
      series.columns.template.setAll({
        tooltipText:
          "{category}: {value} {!! trans('share.views.chart_user') !!}",
        fillOpacity: 1,
        strokeWidth: 0,
        fill: am5.color("#68478D"),
        stroke: am5.color(0xffffff),
      });
  
      // Adaptador para manejar las columnas con valor 0
      series.columns.template.adapters.add("stroke", function (stroke, target) {
        return target.dataItem.valueY === 0 ? undefined : stroke;
      });
  
      // Añadir la leyenda
      const legend = chart.children.push(
        am5.Legend.new(root, {
          centerX: am5.percent(50),
          x: am5.percent(50),
          y: am5.percent(100),
          marginTop: 0,
        })
      );
  
      // Configurar las etiquetas de la leyenda para que sean de color gris
      legend.labels.template.setAll({
        fontSize: 12,
        fontWeight: "300",
        fill: am5.color(0x6b7280), // text-gray-500
      });
  
      legend.data.push(series);
  
      chart.appear(1000, 100);
  
      configureExporting(root, data);
    });
  }

  return (
    <>
      <div className="p-4">
        <DescriptionHeadings
          title={t("user.views.asistenc")}
          description={t("user.views.attendance_description")}
        />
        <div className="grid grid-cols-12 gap-4">
          <div className="p-4 mt-6 bg-white shadow rounded-lg col-span-12">
            <div className="mb-4">
              <h4 className="text-base font-semibold leading-6 text-gray-900  text-center">
                ACL - CLV
              </h4>
            </div>
            <div className="text-center mb-4 flex justify-center items-center">
              <div className="mb-2 p-4 text-center w-1/2">
                <FontAwesomeIcon
                  icon={faClock}
                  className="h-14 w-14 text-indigo-700"
                />
                <p className="text-sm">{t("kpi.views.Tiempo_de_vida")}</p>
                <a href="#" className="mt-4 block">
                  <p
                    className="text-indigo-700 text-4xl"
                    id="customer_lifetime_value"
                  >
                    {statusClients && statusClients[4]} meses
                  </p>
                </a>
              </div>
              <div className="flex items-center">
                <div className="border-l border-gray-200 h-24 mx-4"></div>
              </div>{" "}
              <div className="mb-2 p-4 text-center w-1/2">
                <FontAwesomeIcon
                  icon={faCircleDollar}
                  className="h-14 w-14 text-indigo-700"
                />
                <p className="text-sm">{t("kpi.views.Valor_Vida")} (CLV)</p>
                <a href="#" className="mt-4 block">
                  <p
                    className="text-indigo-700 text-4xl"
                    id="customer_lifetime_value"
                  >
                    {statusClients && numberFormat(statusClients[5], 2)}
                  </p>
                </a>
              </div>
            </div>

            <div className="flex flex-wrap items-center justify-center gap-4 w-full">
              <InputWithCornerHint
                label={t("posts-master.views.age")}
                span=""
                id="age"
                name="age"
                type="number"
                placeholder="0"
                value={ageMin}
                onChange={(e) => setAgeMin(Number(e.target.value))}
              />
              <p className="text-sm text-gray-500">
                {t("posts-master.views.age_between")}
              </p>
              <InputWithCornerHint
                label={t("posts-master.views.age")}
                span=""
                id="age"
                name="age"
                type="number"
                placeholder="100"
                value={ageMax}
                onChange={(e) => setAgeMax(Number(e.target.value))}
              />
              <Select
                name=""
                options={optionsGender}
                tittle={t("posts-master.views.sex")}
                selected={sexSelected}
                setSelected={setSexSelected}
              />
              <Select
                name=""
                options={optionsCurrencies}
                tittle={t("store.views.form.currency")}
                selected={currencySelected}
                setSelected={setCurrencySelected}
              />
              <DateRangePicker
                label={`${t("kpi.views.Inicio")} - ${t("kpi.views.Final")}`}
                id="2"
                value={{
                  startDate: parseDateUTC(
                    new Date().toISOString().split("T")[0]
                  ),
                  endDate: parseDateUTC(
                    new Date().toISOString().split("T")[0]
                  ),
                }}
                onDateChange={(startDate: Date, endDate: Date) => {
                  // Se agrega la funcion para cuando cambie la fecha
                }}
              />
              <Select
                name=""
                options={revenueOption()}
                tittle={t("kpi.views.Fuente_ingresos")}
                selected={revenueSelected}
                setSelected={setRevenueSelected}
              />
            </div>
          </div>
          <div className="p-4 mt-6  bg-white shadow rounded-lg col-span-12">
            <div className="mb-4">
              <h4 className="text-base font-semibold leading-6 text-gray-900  text-center">
                {t("user.views.disegn_plan")}
              </h4>
            </div>
            <div className="text-center mb-4 flex justify-center items-center">
              <div className="mb-2 p-4 text-center w-1/2">
                <FontAwesomeIcon
                  icon={faDumbbell}
                  className="h-14 w-14 text-indigo-700"
                />
                <p className="text-base">{t("user.views.main_message5")}</p>
                <a
                  href="/kpis/absences"
                  className="mt-4 block"
                  target="_blank"
                >
                  <p
                    className="text-indigo-700 text-4xl"
                    id="customer_lifetime_value"
                  >
                    {statusClients ? statusClients[0] : null}
                  </p>
                </a>
              </div>
              <div className="flex items-center">
                <div className="border-l border-gray-200 h-24 mx-4"></div>
              </div>{" "}
              <div className="mb-2 p-4 text-center w-1/2">
                <FontAwesomeIcon
                  icon={faCalendarCircleUser}
                  className="h-14 w-14 text-indigo-700"
                />
                <p className="text-base">
                  {t("user.views.main_message6")} (CLV)
                </p>
                <a
                  href="/kpis/absences-lessons"
                  className="mt-4 block"
                  target="_blank"
                >
                  <p
                    className="text-indigo-700 text-4xl"
                    id="customer_lifetime_value"
                  >
                    {statusClients && statusClients[1]}
                  </p>
                </a>
              </div>
              <div className="flex items-center">
                <div className="border-l border-gray-200 h-24 mx-4"></div>
              </div>
              <div className="mb-2 p-4 text-center w-1/2">
                <FontAwesomeIcon
                  icon={faPersonWalking}
                  className="h-14 w-14 text-indigo-700"
                />
                <p className="text-base">
                  {t("user.views.main_message7")} (CLV)
                </p>
                <a
                  href="/kpis/absences-program"
                  className="mt-4 block"
                  target="_blank"
                >
                  <p
                    className="text-indigo-700 text-4xl"
                    id="customer_lifetime_value"
                  >
                    {statusClients?.[2] ?? null}
                  </p>
                </a>
              </div>
            </div>
          </div>
          <div className="p-4 mt-6  bg-white shadow rounded-lg col-span-12 min-h-96">
            <div className="mb-4">
              <h4 className="text-base font-semibold leading-6 text-gray-900  text-center">
                {t("user.views.customer_acquisition")}
              </h4>
            </div>
            <div className="text-center mb-4 flex justify-center items-center">
              <div
                id="chart_user_constiation"
                style={{ width: "100%", height: "400px" }}
              ></div>
            </div>
          </div>
          <div className="p-4 mt-6  bg-white shadow rounded-lg col-span-6 min-h-96">
            <div className="mb-4">
              <h4 className="text-base font-semibold leading-6 text-gray-900  text-center">
                {t("user.views.main_message1")}
              </h4>
            </div>
            <div className="text-center mb-4 flex justify-center items-center">
              <div
                id="chart_12"
                style={{ width: "100%", height: "400px" }}
              ></div>
            </div>
          </div>
          <div className="p-4 mt-6  bg-white shadow rounded-lg col-span-6 min-h-96">
            <div className="mb-4">
              <h4 className="text-base font-semibold leading-6 text-gray-900  text-center">
                {t("user.views.main_message2")}
              </h4>
            </div>
            <div className="text-center mb-4 flex-col justify-center items-center">
              <div
                id="chart_31"
                style={{ width: "100%", height: "400px" }}
              ></div>
              <div className="flex flex-wrap items-center justify-between px-5">
                <div className="w-1/2">
                  <div className="flex flex-wrap items-center justify-between px-5">
                    <div className="w-1/2">
                      <div className="text-gray-500 mt-2">
                        <small>{t("user.views.main_message3")}</small>
                      </div>
                    </div>
                    <div className="w-1/2">
                      <button
                        id="data_31"
                        className="btn btn-default font-bold py-3 px-6"
                      >
                        {userTotalBranch && userTotalBranch}
                      </button>
                    </div>
                  </div>
                </div>
                <div className="w-1/2">
                  <div className="flex flex-wrap items-center justify-between px-5">
                    <div className="w-1/2">
                      <div className="text-gray-500 mt-2">
                        <small>{t("user.views.main_message4")}</small>
                      </div>
                    </div>
                    <div className="w-1/2">
                      {userAverageBranch &&
                        numberFormat(userAverageBranch, 2, ".", "")}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CaptationFidelizationComponent;
